import React from "react";
import TransactionItemMobile from "./TransactionItemMobile";

export default function TransactionListMobile(props) {
    return (
        <div style={{ overflowY: "scroll", height: props.height }}>
            <p
                style={{
                    fontWeight: "bold",
                    textAlign: "right",
                    marginRight: 5,
                    marginTop: "2%",
                    fontSize: 20
                }}
            >
                {props.label}
            </p>
            <div style={{ marginTop: 6, marginBottom: 20 }}>
                {props.transactions.map((item) => {
                    return (
                        <div key={item.id} style={{ marginBottom: "3%" }}>
                            <TransactionItemMobile
                                item={item}
                                transactionType={props.transactionType}
                            />
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
